import { toast } from "react-toastify"

function Toast(message: string, isSuccess: boolean): any {
  return toast(message, {
    type: isSuccess ? toast.TYPE.SUCCESS : toast.TYPE.ERROR
  })
}

export default Toast
